import React from "react";
import { t } from "utils/i18n";
import WhatIDo from "./WhatIDo";

const About = () => {
  return (
    <div className="new-tab-content-container">
      <h1>About</h1>
      <p>
        {t("label.self.statement")}
        <br /> <br />
        {t("label.paragraph.second")}
      </p>
      <WhatIDo />
    </div>
  );
};

export default About;
